<template>
    <div>
        <div class="remarks">
            <div class="title-warp">
                <div class="title">
                    检查意见
                </div>
                <div class="radio-group">
                    <el-radio-group v-model="formData.qualifiedSelect" style="margin-top: 10px"
                        :disabled="pageType == 'record' ? true : false" lable="检查意见" @change="setSession">
                        <el-radio :label="1">合格</el-radio>
                        <el-radio :label="2">不合格</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="check-cotent">
                <el-input v-model.trim="formData.remarks" type="textarea" :row="2" style="width: 100%" maxlength="200"
                    placeholder="请输入详细检查意见" :disabled="pageType == 'record' ? true : false" @blur="setSession"></el-input>
            </div>
        </div>
        <div class="info-detial">
            <searchForm v-model="searchData" @getList="getList(1)" :labelList="searchLabelList" :searchData="searchData"
                @reset="resetForm" :showExport="false" :isShowAddress="true"></searchForm>

            <div class="my-table">
                <myTable :selection="false" :page="page" :showpage="true" :operation="false" v-loading="loading"
                    :table-data="tableData" :table-option.sync="tableOption" @page-change="getList" :expand="false">
                    <template slot="operation" slot-scope="scope">
                        <div style="margin: 0 0px">
                            <el-link type="primary" :underline="false" @click="checkDetails(scope.row, 1)"
                                style="margin-right: 10px">
                                详情
                            </el-link>
                        </div>
                    </template>

                    <template slot="contactsName" slot-scope="scope">
                        <div style="margin: 0 0px">
                            <div>{{ scope.row.contactsName || '' }}</div>
                            <div>{{ scope.row.contactsPhone || '' }}</div>
                            <div>{{ scope.row.address || '' }}</div>
                        </div>
                    </template>
                    <!-- amount -->

                    <template slot="status" slot-scope="scope">
                        <div style="margin: 0 0px">
                            <span v-if="scope.row.status == 'CHECKING'">审核中</span>
                            <span v-if="scope.row.status == 'WAIT_SALE'">待退货</span>
                            <span v-if="scope.row.status == 'SALEING'">退货中</span>
                            <span v-if="scope.row.status == 'REFUNDING'">退款中</span>
                            <span v-if="scope.row.status == 'FINISH'">退款成功</span>
                            <span v-if="scope.row.status == 'REJECT'">驳回</span>
                            <span v-if="scope.row.status == 'CANCEL'">关闭</span>
                        </div>
                    </template>

                    <template slot="amount" slot-scope="scope">
                        <div style="margin: 0 0px">
                            ￥ <span>{{ parseFloat(scope.row.amount).toFixed(2) || '0.00' }}</span>
                        </div>
                    </template>

                    <template slot="chekItem" slot-scope="scope" fixed="right">
                        <div style="margin: 0 0px">
                            <el-radio-group v-model="scope.row.qualifiedSelect" style="margin-top: 10px" lable=""
                                :disabled="pageType == 'record' ? true : false" @change="saveTemporaryCheckFn(scope.row)">
                                <el-radio :label="0">待检查</el-radio>
                                <el-radio :label="1">合格</el-radio>
                                <el-radio :label="2">不合格</el-radio>
                            </el-radio-group>
                        </div>
                    </template>
                </myTable>
            </div>
        </div>
    </div>
</template>
<script>
import InfoDetail from "./children/infoDetail.vue";
import searchForm from "../component/searchForm.vue";
import myTable from "@/components/myTable";
import { getAfterSaleOrderCheckPage } from "@/api/servicecenter/pendingPayment";
import {
    saveTemporaryCheck,
    queryCheckRecordDetail
} from "@/api/shopmange";
export default {
    name: "checkShop_afterSales",
    components: { InfoDetail, searchForm, myTable },
    watch: {
        modeValue: {
            immediate: true,
            handler: function (value) {
                console.log(value, "value");
            },
        },
    },
    props: {
        //pageType: check 检查，record 记录
        pageType: {
            type: String,
            default: 'check'
        }
    },
    data() {
        return {
            loading: false,
            page: {
                total: 0,
                current: 1,
                size: 10,
                pageSizes: [10, 20, 30, 50],
            },
            searchData: {
                qualifiedSelect: ''
            }, tableData: [],
            tableOption: [
                { label: "单据创建时间", prop: "orderTime", width: 200 },
                { label: "订单编号", prop: "orderCode", width: 200 },
                { label: "客户ID", prop: "payShopCode", width: 160 },
                { label: "客户名称", prop: "payShopName" },
                { label: "单据金额", prop: "amount", width: 120, slot: true },
                { label: "单据状态", prop: "status", slot: true },
                { label: "收货信息", prop: "contactsName", width: 360, slot: true },
                { label: "客户类型", prop: "shopType" },
                {
                    label: "操作",
                    prop: "operation",
                    slot: true,
                    width: 120,
                    // fixed: "right",
                },
                { label: "检查细项", prop: "chekItem", slot: true, width: 260 },

            ],
            searchLabelList: [
                {
                    name: "单据状态",
                    width: 150,
                    fieldName: "status",
                    type: "select",
                    disabled: false,
                    select: [
                        {
                            id: 'CHECKING',
                            name: '审核中',

                        },
                        {
                            id: 'WAIT_SALE',
                            name: '待退货',

                        },
                        {
                            id: 'SALEING',
                            name: '退货中',

                        },
                        {
                            id: 'REFUNDING',
                            name: '退款中',

                        },
                        {
                            id: 'FINISH',
                            name: '退款成功',

                        },
                        {
                            id: 'CANCEL',
                            name: '退款关闭',

                        },
                        {
                            id: 'REJECT',
                            name: '驳回',
                        }
                    ],

                },

                {
                    name: "客户名称",
                    fieldName: "payShopName",
                    type: "input",
                    disabled: false,
                },
                {
                    name: "单据编号",
                    fieldName: "orderCode",
                    type: "input",
                },
                {
                    name: "单据创建日期",
                    fieldName: "date",
                    type: "date",
                },
                {
                    name: "检查状态",
                    width: 150,
                    fieldName: "qualifiedSelect",
                    type: "select",
                    disabled: false,
                    select: this.pageType == 'record' ? [

                        {
                            name: "合格",
                            id: 1,
                        },
                        {
                            name: "不合格",
                            id: 2,
                        }
                    ]
                        : [
                            {
                                name: "待检查",
                                id: 0,
                            },
                            {
                                name: "合格",
                                id: 1,
                            },
                            {
                                name: "不合格",
                                id: 2,
                            }
                        ]
                    ,
                },
            ],
            isRecord: false,
            formData: {
                qualifiedSelect: 0,
                remarks: '',
                shopId: ''
            },
            type: "approve", // view
            status: null,
            roleId: null,
            relationType: null,
            shopTypeName: null,
            shopName: null,
            orgCode: null,
            deptId: null,
            disabled: true,
            remarks: "",
            infoDetailData: {},
            queryScopeListData: [],
        };
    },
    activated() {
        console.log("这是一个被缓存的组件");
        // this.getList();
    },
    methods: {
        // 保存资质细项检查结果（临时表）
        saveTemporaryCheckFn(item) {
            let parmas = item;
            parmas.shopId = this.$route.query.shopId;
            saveTemporaryCheck(parmas, 'afterSaleOrder').then(res => { }).catch(err => { })
        },
        // 获取session,回显
        getSeesion() {
            this.formData.shopId = this.$route.query.shopId;
            let checkShopItemSession = window.sessionStorage.getItem('checkShopItemSession');
            if (checkShopItemSession && this.pageType == 'check') {
                checkShopItemSession = JSON.parse(checkShopItemSession);
                if (checkShopItemSession.shopId == this.formData.shopId) {
                    this.formData.qualifiedSelect = checkShopItemSession.afterSales.qualifiedSelect;
                    this.formData.remarks = checkShopItemSession.afterSales.remarks;
                }
            }

            if (this.pageType == 'record') {
                console.log('查询afterSales 记录')
            }
        },
        setSession() {
            this.formData.shopId = this.$route.query.shopId;
            let checkShopItemSession = window.sessionStorage.getItem('checkShopItemSession');
            if (checkShopItemSession) {
                checkShopItemSession = JSON.parse(checkShopItemSession);
                if (checkShopItemSession.shopId == this.formData.shopId) {
                    checkShopItemSession.afterSales.qualifiedSelect = this.formData.qualifiedSelect;
                    checkShopItemSession.afterSales.remarks = this.formData.remarks;
                    window.sessionStorage.setItem('checkShopItemSession', JSON.stringify(checkShopItemSession));
                }
            }
            // window.sessionStorage('checkStatus')
        },
        // 查看详情
        goBaseDepotPage(pathUrl) {
            let routeData = this.$router.resolve({
                path: pathUrl,
                query: {},
                params: {}
            })
            window.open(routeData.href, '_blank')
        },
        checkDetails(row) {
            if (row.recordId) {
                this.goBaseDepotPage(`./businessManage-checkShop-afterSalesDetail?recordId=${row.recordId}&pageType=${this.pageType}`)
            } else {
                this.goBaseDepotPage(`./businessManage-checkShop-afterSalesDetail?id=${row.id}&pageType=${this.pageType}`)
            }

        },
        getList(current) {
            if (current) { // 搜索条件改变从第一页开始查询
                this.page.current = current
            }
            if (this.searchData.date) {
                this.searchData.startOrderTime	 = this.searchData.date[0];
                this.searchData.endOrderTime = this.searchData.date[1];
            }
            console.log(this.searchData)
            const params = Object.assign({}, this.searchData);
            params.size = this.page.size;
            params.shopId = this.$route.query.shopId;
            console.log(params)
            if(params.date) {
            delete params.date; 
            }

            if (current) {
                params.current = 1;
            } else { 
                params.current = this.page.current;
            }

            if (this.pageType == 'record') {
                console.log('查询afterSales 记录')
                params.type = 4;
                params.recordId = this.$route.query.recordId;
                params.orderStatus = params.status;
                this.queryCheckRecordDetailFn(params);
            } else {
                getAfterSaleOrderCheckPage(params).then((res) => {
                    if (res) {
                        this.tableData = res.records;
                        this.page.total = res.total;
                    } else {
                        this.tableData = [];
                        this.page.total = 0;
                    }
                });
            }

        },
        // 查询检查记录列表 检查类型  type 1-资质 2-商品 3-订单 4-售后订单
        // recordId 检查记录id
        queryCheckRecordDetailFn(params) {
            queryCheckRecordDetail(params).then(res => {
                if (res && res.checkRecordDetails) {
                    this.tableData = res.checkRecordDetails.records
                    this.page.total = res.checkRecordDetails.total;
                    this.formData.qualifiedSelect = res.globalQualifiedSelect;
                    this.formData.remarks = res.remarks;
                } else {
                    this.tableData = []
                    this.page.total = 0
                }

            }).catch(err => {

            });
        },

        back() {
            this.$router.go(-1);
        },
        openReject() {
            this.$refs.RejectDialog.openDialog();
        },
        openConfirm() {
            this.$refs.ConfirmDialog.openDialog();
        },

        resetForm() {
            this.page.current = 1;
            this.page.size = 10;
            Object.keys(this.searchData).forEach(
                (key) => (this.searchData[key] = "")
            );
            this.getList(1)
         }
    },
    mounted() {
        this.getList();
        this.getSeesion();
    },
};
</script>
<style lang="scss" scoped>
.filedsContainer {
    display: flex;
    flex-flow: column;
    height: 100%;
    overflow-y: auto;

    .head {
        background: #ffffff;
        height: 76px;
        padding: 10px;
        line-height: 28px;
    }

    .font-tip {
        padding-left: 20px;
        font-size: 12px;
    }

    .footer {
        padding: 20px;
        background: #ffffff;
    }

    .remarks {
        background: #ffffff;
        padding: 0 0px 20px;

        .title-warp {
            display: flex;
        }

        .title {
            line-height: 30px;
            font-size: 16px;
            // width: 200px;
            //display: flex;
            // justify-content: space-between; 
        }

        .radio-group {
            margin-left: 10px;
        }
    }

    .info-detial {
        padding: 0 0px 0px;
        width: calc(100% - 0px);
    }

    .my-table {
        height: calc(100vh - 480px);
    }
}
</style>
  